import PropTypes from 'prop-types';
import React from 'react';
import MediaQuery from '../common/media_query';
import Ad from '../common/ad';
import { map } from 'lodash';
import { HEADER_AD_SIZES } from '../../utils/ads/sizes';

const HeaderAd = ({ adsState }) => (
  <div>
    {
      map(HEADER_AD_SIZES, (sizes, breakpoint) => (
        <MediaQuery breakpoint={breakpoint} key={breakpoint}>
          <Ad adsState={adsState}
            sizes={sizes}
            position="header"
            uniqueId="header"
          />
        </MediaQuery>
      ))
    }
  </div>
);

HeaderAd.propTypes = {
  adsState: PropTypes.object.isRequired
};

export default HeaderAd;
